
export const reducerSetSearch = (state, search) => {

  return {
    ...state,
    search,
  }
}
